// extracted by mini-css-extract-plugin
module.exports = {"logo":"footer-module--logo--9q-NC","socialLink":"footer-module--socialLink--cNqqU"};